const ORDERBOOK_DEPTH = 10

export { ORDERBOOK_DEPTH }